import { useLang } from "../context/LanguageContext";

export default function LanguageToggle() {
  const { lang, setLang } = useLang();
  const isEN = lang === "en";

  return (
    <div className="lang-pill" dir="ltr" data-testid="lang-toggle">
      <span
        className="pill-indicator"
        style={{
          transform: isEN ? "translateX(0)" : "translateX(100%)",
        }}
      />
      <button
        type="button"
        onClick={() => setLang("en")}
        data-active={isEN}
        data-testid="lang-toggle-en"
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang("he")}
        data-active={!isEN}
        data-testid="lang-toggle-he"
      >
        HE
      </button>
    </div>
  );
}
